// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchPanel_searchPanelItems__5NcN9 {
    position: relative;
    z-index: 3;
    top: 2px;
  
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
  
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 10px;
    padding: 0px 10px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 0.25rem;
    background-color: rgb(243 245 247 / 100%);
    color: #5D6570;
    line-height: 20px;
  
    font-weight: 500;
    font-size: 14px;
  }

  .searchPanel_searchInput__KzkXM {
    height: 32px;
    width: 180px; 
    padding: 4px 8px; 
    margin-left: 8px;
    margin-right: 16px;
    border: 1px solid #828C99; 
    color: #13151A;
    border-radius: 8px; 
    transition: border-color 0.3s ease; 
  }
  
  .searchPanel_searchInput__KzkXM:focus {
    outline: none; 
  }

  .searchPanel_separator__8k2zL {
    width: 2px;
    height: 24px;
    margin: 0 16px;
  
    background-color: #E6E9ED;
  }

`, "",{"version":3,"sources":["webpack://./src/components/form/Editor/plugins/SearchFullTextPlugin/searchPanel.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;;IAER,aAAa;IACb,mBAAmB;IACnB,eAAe;;;IAGf,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;IAClB,sBAAsB;IACtB,yCAAyC;IACzC,cAAc;IACd,iBAAiB;;IAEjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,cAAc;;IAEd,yBAAyB;EAC3B","sourcesContent":[".searchPanelItems {\n    position: relative;\n    z-index: 3;\n    top: 2px;\n  \n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    \n  \n    box-sizing: border-box;\n    height: 40px;\n    margin-bottom: 10px;\n    padding: 0px 10px;\n    width: fit-content;\n    border-radius: 0.25rem;\n    background-color: rgb(243 245 247 / 100%);\n    color: #5D6570;\n    line-height: 20px;\n  \n    font-weight: 500;\n    font-size: 14px;\n  }\n\n  .searchInput {\n    height: 32px;\n    width: 180px; \n    padding: 4px 8px; \n    margin-left: 8px;\n    margin-right: 16px;\n    border: 1px solid #828C99; \n    color: #13151A;\n    border-radius: 8px; \n    transition: border-color 0.3s ease; \n  }\n  \n  .searchInput:focus {\n    outline: none; \n  }\n\n  .separator {\n    width: 2px;\n    height: 24px;\n    margin: 0 16px;\n  \n    background-color: #E6E9ED;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchPanelItems": `searchPanel_searchPanelItems__5NcN9`,
	"searchInput": `searchPanel_searchInput__KzkXM`,
	"separator": `searchPanel_separator__8k2zL`
};
export default ___CSS_LOADER_EXPORT___;
